<template>
  <div class="attach-component">
    <div class="attach-list">
      <div class="attach-menu">
        <router-link
          to="/attach/attachfile"
          class="attach-menu-title"
          active-class="active"
          >{{$t("Header_Attachments")}}</router-link
        >
        <router-link
          to="/attach/sample"
          class="attach-menu-title"
          active-class="active"
          >{{$t("Attach_1")}}</router-link
        >
      </div>
    </div>
    <div class="attach-contents">
      <router-view />
    </div>
  </div>
</template>

<script>
import { onMounted, toRefs, reactive, watch, computed } from "vue";
import { apiUrl } from "@/utils/common";
import { useStore } from "vuex";
import axios from "axios";

// redirect 경로 설정
export const redirectName = "attachfile";

export default {
  name: "Attach",
  setup() {},
};
</script>

<style>
</style>